export default {
  init() {
    if ($('.slider-single').length) {
      $('.slider-single').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
      });
    }

    const wrappers = document.querySelectorAll('.parallax-wrapper');

    wrappers.forEach((wrapper, i) => {
      const img = wrapper.querySelector('img');

      wrapper.addEventListener('mousemove', (e) => {
        const { left, top, width, height } = wrapper.getBoundingClientRect();
        const x = (e.clientX - left) / width - 0.5;
        const y = (e.clientY - top) / height - 0.5;
        img.style.transform = `scale(1.03) translate(${x * 20}px, ${y * 20}px)`;
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js